(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/hooks/use-week-draw-updates.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/hooks/use-week-draw-updates.js');

'use strict';

const {
  drawsOptions
} = svs.gamePackage.data.packageConfig;
const weekDraws = svs.numbergames.draws.getWeekDraws();
const {
  useDispatch
} = ReactRedux;
const {
  updateDraws
} = svs.gamePackage.redux.gamePackageSlice.actions;
function useWeekDrawUpdates() {
  const dispatch = useDispatch();
  React.useEffect(() => {
    const onWeekDrawUpdate = () => dispatch(updateDraws(weekDraws.getDraws(drawsOptions)));
    svs.events.subscribe('/ng/draws/week/updated', onWeekDrawUpdate);
    return () => {
      svs.events.unsubscribe('/ng/draws/week/updated', onWeekDrawUpdate);
    };
  }, [dispatch]);
  return null;
}
svs.gamePackage.hooks.useWeekDrawUpdates = useWeekDrawUpdates;

 })(window);